import { render } from "./userManagement.vue?vue&type=template&id=33f08757&scoped=true"
import script from "./userManagement.vue?vue&type=script&lang=js"
export * from "./userManagement.vue?vue&type=script&lang=js"

import "./userManagement.vue?vue&type=style&index=0&id=33f08757&lang=scss&scoped=true"
import "./userManagement.vue?vue&type=style&index=1&id=33f08757&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f08757"]])

export default __exports__